/* eslint-disable complexity */
import settings from 'Cloud/settings';
import { goTo } from 'reactApp/appHelpers/appHelpers';
import { IS_B2B_BIZ_USER, IS_PHONE_BROWSER, IS_REACT_PROMO_QUOTA_PAGE } from 'reactApp/appHelpers/configHelpers';
import { isTouchSearchEnabled } from 'reactApp/appHelpers/featuresHelpers';
import { changeHomeHistory } from 'reactApp/modules/home/home.actions';
import { changeSearchHistory } from 'reactApp/modules/search/search.actions';
import { store as reduxStore } from 'reactApp/store';
import opener from 'reactApp/utils/opener';

import { CloudFile, CloudItem, EStorageType } from './storage.types';

export const getStorage = (storage: string | null) => {
    const isHome = storage === EStorageType.home;
    const isPublic = storage === EStorageType.public;
    const isSharedAutodelete = storage === EStorageType.sharedAutodelete;
    const isSharedLinks = storage === EStorageType.sharedLinks;
    const isSharedIncoming = storage === EStorageType.sharedIncoming;
    const isTrashBin = storage === EStorageType.trashbin;
    const isAttaches = storage === EStorageType.attaches || storage === EStorageType.viewerAttaches;
    const isSearch = storage === EStorageType.search;
    const isFavorites = storage === EStorageType.favorites;
    const isStock = storage === EStorageType.stock;
    const isFeed = storage === EStorageType.feed;
    const isStart = storage === EStorageType.start;
    const isGallery = storage === EStorageType.gallery;
    const isRecommend = storage === EStorageType.recommend;
    const isDocuments = storage === EStorageType.documents;
    const isStory = storage === EStorageType.story;
    const isEditor = storage === EStorageType.office || storage === EStorageType.r7 || storage === EStorageType.myoffice;
    const isAttachesStorage = storage === EStorageType.attaches;
    const isAlbums = storage === EStorageType.albums;
    const isQuotaCleaner = storage === EStorageType.quotaCleaner;
    const isQuotaPartner = storage === EStorageType.quotaPartner;
    const isQuotaTariffs = storage === EStorageType.quotaTariffs;
    const isPromocodes = storage === EStorageType.promocodes;
    const isSubscription = storage === EStorageType.subscriptions;
    const isEmbedded = storage === EStorageType.embedded;

    return {
        isHome,
        isPublic,
        isSharedAutodelete,
        isSharedLinks,
        isSharedIncoming,
        isTrashBin,
        isAttaches,
        isSearch,
        isFavorites,
        isStock,
        isFeed,
        isStart,
        isGallery,
        isRecommend,
        isDocuments,
        isStory,
        isEditor,
        isAlbums,
        isQuotaCleaner,
        isQuotaTariffs,
        isQuotaPartner,
        isEmbedded,
        // Для них в старом дереве не дергаем загрузку из апи, для них все загрузки делаем в сагах.
        isReactDataList:
            isTrashBin ||
            isAttachesStorage ||
            isFavorites ||
            isRecommend ||
            isGallery ||
            isSharedAutodelete ||
            isDocuments ||
            isSharedIncoming ||
            isSharedLinks ||
            isSearch,
        isReactPage:
            isHome ||
            isGallery ||
            isFavorites ||
            isDocuments ||
            isSharedAutodelete ||
            isStart ||
            isAlbums ||
            isQuotaCleaner ||
            isTrashBin ||
            isFeed ||
            isRecommend ||
            isPromocodes ||
            isSubscription ||
            isSharedIncoming ||
            isSharedLinks ||
            isAttachesStorage ||
            isSearch ||
            isEmbedded,
        isPrivatePage:
            isHome ||
            isGallery ||
            isFavorites ||
            isDocuments ||
            isSharedAutodelete ||
            isStart ||
            isAlbums ||
            isDocuments ||
            isTrashBin ||
            isFeed ||
            isRecommend ||
            isSharedIncoming ||
            isSharedLinks ||
            isAttachesStorage,
        isPublicOrStock: isPublic || isStock,
        isNewQuotaLanding: isQuotaPartner || isQuotaTariffs,
        isSubscription,
    };
};

let lastId = '';

// выпилить navigateStorage когда будет нормальный хелпер
export const changeStorageHistory = ({
    id,
    storage,
    navigateToStorage,
    search = '',
}: {
    id?: string;
    search?: string;
    storage?: EStorageType;
    navigateToStorage?: EStorageType;
}) => {
    if (storage === EStorageType.home && id) {
        if (lastId !== id) {
            reduxStore.dispatch(changeHomeHistory({ id, search }));
        }
        lastId = id;
        return;
    }

    if (isTouchSearchEnabled && IS_PHONE_BROWSER && storage === EStorageType.search && id) {
        reduxStore.dispatch(changeSearchHistory({ id }));
        return;
    }

    if (navigateToStorage) {
        opener(`/${navigateToStorage}${id || ''}`, true);
    } else {
        goTo({ id, storage });
    }
};

export const getPageSubtitle = () => {
    if (IS_REACT_PROMO_QUOTA_PAGE) {
        return 'Единое хранилище Почты и Облака';
    }
    return IS_B2B_BIZ_USER ? 'VK WorkDisk' : 'Облако Mail.ru';
};

export const getPageTitleByStorage = (storage, itemTitle): string => {
    const title = itemTitle ? itemTitle : settings?.storages?.[storage]?.title;
    const subTitle = getPageSubtitle();

    return title ? `${title} / ${subTitle}` : subTitle;
};

export const DEFAULT_API_LIMIT = 500;

export const getLoadMoreLimit = (storage: EStorageType): number => {
    if ([EStorageType.home, EStorageType.public, EStorageType.sharedLinks, EStorageType.sharedIncoming].includes(storage)) {
        return DEFAULT_API_LIMIT;
    }

    if (storage === EStorageType.favorites) {
        return 1000;
    }

    if (storage === EStorageType.search) {
        return 10000;
    }

    return 100;
};

export const isCloudFile = (item?: CloudItem | null): item is CloudFile => !!item && !item.isFolder;

export const getIdByStorage = (storage: EStorageType) => {
    return `/${storage}`;
};
